import { MerchantId, SetHeaderService } from "@/helper/userHelper";
import service from "../baseHttpService";

class UserService {
  DoGetUserDetailForDisplay(userIdList: any) {
    return service.peakExportAPI
      .post(
        "/api/User/GetUserDetailListForDisplay",
        {
          merchantId: MerchantId(),
          userIdList: userIdList,
        },
        SetHeaderService()
      )
      .then((res) => {
        return res;
      });
  }
  DoGetUserInAppPEAKBoard(input: any) {
    return service.peakRealTimeAPI.post("/api/User/GetUserInAppPEAKBoard", input, SetHeaderService()).then((res) => {
      return res.data;
    });
  }
  DoSendVideoFeedback(input: any) {
    return service.peakExportAPI
      .post("/api/User/UserFeedbackVideo", input, SetHeaderService())
      .then((res) => {
        return res.data;
      })
      .catch((err: any) => err);
  }
  DoGetVideoFeedback(input: any) {
    return service.peakExportAPI
      .post("/api/User/GetUserFeedbackVideo", input, SetHeaderService())
      .then((res) => {
        return res.data;
      })
      .catch((err: any) => err);
  }
}
export default new UserService();
